import React from 'react';
import { Field, reduxForm } from 'redux-form';
import CheckboxField from '../../../../shared/form-elements/checkbox';

const PopupContent = props => {
	return (
		<div className="adv-request__wrap padding-10-15">
			<form>
				<Field
					name="is_profit_visible"
					searchable={false}
					component={CheckboxField}
					placeholder="Profit visible?"
					options={props.prolongRequestTypes}
					onChange={props.changeProfitVisibility}
				/>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'limitedGarantsProfitForm'
})(PopupContent);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants-analysis/list/components/forms/limited-garants-profit-form.js